import React, { useMemo } from 'react'
import { useDefaultPath } from '../../hooks/useDefautPath'
import { routersPath } from '../../router/routes-path'
import { useUserSelector } from '../../store/selectors/auth'
import styles from './NotFound.module.scss'
import Box from '../../components/ui/Box/Box'

const NotFound: React.FC = () => {
  const user = useUserSelector()
  const redirect = useDefaultPath()
  const getRedirect = useMemo(() => {
    return user ? redirect : routersPath.LOGIN_PAGE
  }, [user])

  return (
    <div className={styles.container}>
      <Box className={styles.card}>
        <>
          <h1>CRMBRO</h1>
          <img src={`/img/404.png`} alt='404' />
          <div className={styles.title}>Нет доступа к странице</div>
          <p>Вернитесь на главную панель управления и продолжите работу.</p>
          <a className={styles.link} href={getRedirect}>
            Вернуться на главную
          </a>
        </>
      </Box>
    </div>
  )
}

export default NotFound
